import type { Me } from "../shared/types";
import { api } from "./lib";

export type Config = { models: Record<string, { ko: string; credits: Record<string, number> }>; signupCredits: number; devAuth: boolean; fakeAi?: boolean };

export const state: { me: Me | null; config: Config | null } = { me: null, config: null };

/** 크레딧이 이보다 적으면 머리띠 알약이 주황이 된다 */
export const LOW_CREDITS = 5;

export const creditLabel = (n: number) => `남은 크레딧 ${n} · 기본 그림 한 장 1 크레딧`;

/** 머리띠 크레딧 숫자만 바꾼다 */
function paintCredits() {
  const badge = document.getElementById("credit-badge");
  if (!badge || !state.me) return;
  const n = state.me.credits;
  const v = badge.querySelector(".v");
  if (v) v.textContent = String(n);
  badge.classList.toggle("low", n < LOW_CREDITS);
  badge.setAttribute("title", creditLabel(n));
  badge.setAttribute("aria-label", creditLabel(n));
}

export async function refreshMe() {
  state.me = await api<Me>("/api/me");
  paintCredits();
}

/** 주소를 바꾼다. 같은 주소면 화면만 다시 그린다 */
export function go(hash: string) {
  if (location.hash === hash) window.dispatchEvent(new Event("rerender"));
  else location.hash = hash;
}
